import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function DictamenDeDisenoPlanos() {
  return <CategoryPage category="dictamenDeDisenoPlanos" pageTitle="Planos" />;
}

export default DictamenDeDisenoPlanos;
